import { SessionManagement_V1 } from "@rw1/auto-generated-clients";
import { UserSession } from "../models/session";

export const toUserSession = (
  dataPoint: SessionManagement_V1.UserSessionDataPoint,
): UserSession => ({
  userId: dataPoint.userId,
  experienceName: dataPoint.experienceName,
  contentMetadataId: dataPoint.contentMetadataId,
  sessionStartTime: dataPoint.sessionStartTime,
  sessionDurationInSeconds: dataPoint.sessionDurationInSeconds,
  multiplayerSessionId: dataPoint.multiplayerSessionId,
  country: dataPoint.country,
});
